<template>
  <div>
    <h3>{{ $t("symptoms") }}</h3>
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th colspan="2">{{ $t("answerdYes") }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="evidence in evidences">
          <tr
            :key="evidence.id"
            v-if="evidence.choice === 'present' && evidence.name[$i18n.locale]"
          >
            <td class="text-success text-center">
              <yes-icon></yes-icon>
            </td>
            <td>{{ evidence.name[$i18n.locale] }}</td>
          </tr>
        </template>
      </tbody>
      <thead>
        <tr>
          <th colspan="2">{{ $t("answerdNo") }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="evidence in evidences">
          <tr
            :key="evidence.id"
            v-if="evidence.choice === 'absent' && evidence.name[$i18n.locale]"
          >
            <td class="text-danger text-center"><no-icon></no-icon></td>
            <td>{{ evidence.name[$i18n.locale] }}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import YesIcon from '@/components/Icons/Yes'
import NoIcon from '@/components/Icons/No'
export default {
  components: {
    YesIcon,
    NoIcon
  },
  props: {
    evidences: {
      type: Array,
      required: true
    }
  }
}
</script>
<i18n>
{
  "ka": {
    "symptoms": "სიმპტომები",
    "answerdYes": "უპასუხა დადებითად",
    "answerdNo": "უპასუხა უარყოფითად"
  },
  "en": {
    "symptoms": "Evidences",
    "answerdYes": "Present",
    "answerdNo": "Absent"
  }
}
</i18n>
